export default {
    "name": "ValidateSalesOrder",
    "kind": "HoudiniQuery",
    "hash": "c11df4c07225ebbf4887669e523efa12bf4d288e5f5dd76037c0b968f60dfc97",

    "raw": `query ValidateSalesOrder($key: SalesOrderKey!) {
  salesOrder(key: $key) {
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "salesOrder": {
                "type": "SalesOrder",
                "keyRaw": "salesOrder(key: $key)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "key": "SalesOrderKey"
        },

        "types": {
            "SalesOrderKey": {
                "salesOrderId": "UInt",
                "storeId": "UInt"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=0e0117916d1869d31d16b63a3dfd57018f52a48ab1785cc55b85c26b0232f6f3";